import React, { useEffect, useState, useRef } from 'react';
import { CheckCircle, Gift, BookOpen, Clock, AlertTriangle } from 'lucide-react';
const handlePurchaseClick = () => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Cría con calma - Pricing Section',
        content_category: 'Parenting Guide',
        value: 7.99,
        currency: 'USD'
      });
      window.fbq('track', 'AddToCart', {
        content_name: 'Cría con calma Kit Completo',
        content_ids: ['40777014116416'],
        content_type: 'product',
        value: 7.99,
        currency: 'USD'
      });
      console.log('✅ InitiateCheckout and AddToCart tracked from Pricing');
    }
  } catch (error) {
    console.error('❌ Error tracking purchase click:', error);
  }
};
export function Pricing() {
  const sectionRef = useRef<HTMLElement>(null);
  const hasTracked = useRef(false);
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasTracked.current) {
          try {
            if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
              window.fbq('track', 'ViewContent', {
                content_name: 'Pricing Section',
                content_category: 'Parenting Guide',
                content_ids: ['40777014116416'],
                value: 7.99,
                currency: 'USD'
              });
              console.log('✅ ViewContent (Pricing) event tracked');
              hasTracked.current = true;
            }
          } catch (error) {
            console.error('❌ Error tracking pricing section view:', error);
          }
        }
      });
    }, {
      threshold: 0.3
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime.seconds > 0) {
          return {
            ...prevTime,
            seconds: prevTime.seconds - 1
          };
        } else if (prevTime.minutes > 0) {
          return {
            ...prevTime,
            minutes: prevTime.minutes - 1,
            seconds: 59
          };
        } else if (prevTime.hours > 0) {
          return {
            hours: prevTime.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          return {
            hours: 23,
            minutes: 59,
            seconds: 59
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Format time with leading zeros
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section ref={sectionRef} className="py-16 bg-gradient-to-b from-amber-50 to-white" id="oferta" data-id="element-325">
      <div className="container mx-auto px-4 md:px-6" data-id="element-326">
        <div className="max-w-4xl mx-auto" data-id="element-327">
          <div className="text-center mb-8" data-id="element-328">
            <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-4 font-serif" data-id="element-329">
              Oferta Especial por Tiempo Limitado
            </h2>
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4" data-id="element-330">
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-331">
                <Clock className="text-red-600" size={20} data-id="element-332" />
                <p className="text-red-600 font-bold" data-id="element-333">
                  ¡Esta oferta expira pronto!
                </p>
              </div>
              <div className="flex justify-center gap-3 my-2" data-id="element-334">
                <div className="bg-red-600 text-white rounded-md px-3 py-2 w-16 text-center" data-id="element-335">
                  <span className="text-xl font-bold" data-id="element-336">
                    {formatTime(timeLeft.hours)}
                  </span>
                  <p className="text-xs mt-1" data-id="element-337">horas</p>
                </div>
                <div className="bg-red-600 text-white rounded-md px-3 py-2 w-16 text-center" data-id="element-338">
                  <span className="text-xl font-bold" data-id="element-339">
                    {formatTime(timeLeft.minutes)}
                  </span>
                  <p className="text-xs mt-1" data-id="element-340">minutos</p>
                </div>
                <div className="bg-red-600 text-white rounded-md px-3 py-2 w-16 text-center" data-id="element-341">
                  <span className="text-xl font-bold" data-id="element-342">
                    {formatTime(timeLeft.seconds)}
                  </span>
                  <p className="text-xs mt-1" data-id="element-343">segundos</p>
                </div>
              </div>
            </div>
            <p className="text-lg text-amber-800" data-id="element-344">
              Todo lo que necesitas para transformar las rutinas de tu familia
            </p>
          </div>
          <div className="mb-8 flex justify-center" data-id="element-345">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/19pMdUf472DiUBpAEXGoc8/Gemini_Generated_Image_gdj9axgdj9axgdj9.png" alt="Pack completo: Rutinas Infantiles y Disciplina Positiva - Oferta 3x1" className="rounded-lg shadow-xl max-w-full" data-id="element-346" />
          </div>
          <div className="bg-white rounded-xl shadow-xl border border-amber-100 overflow-hidden" data-id="element-347">
            <div className="bg-amber-700 text-white py-3 text-center" data-id="element-348">
              <p className="font-bold text-lg" data-id="element-349">OFERTA EXCLUSIVA HOY</p>
            </div>
            <div className="p-6 md:p-8" data-id="element-350">
              <div className="bg-amber-50 rounded-lg p-4 border border-amber-200 mb-8" data-id="element-351">
                <div className="flex items-center gap-2 mb-2" data-id="element-352">
                  <BookOpen className="text-amber-700" size={20} data-id="element-353" />
                  <h4 className="font-bold text-amber-900" data-id="element-354">
                    PRODUCTO PRINCIPAL: Valor $27.99
                  </h4>
                </div>
                <div className="flex gap-4" data-id="element-355">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uRDARNppfyVD1qFdCi75bA/ChatGPT_Image_8_oct_2025%2C_12_08_42_a.m..png" alt="Cría con Calma: Kit Completo" className="w-24 h-32 object-cover rounded-md shadow-md" data-id="element-356" />
                  <div data-id="element-357">
                    <h5 className="font-bold text-amber-900" data-id="element-358">
                      Cría con Calma: Kit Completo de Rutinas
                    </h5>
                    <p className="text-sm text-amber-800" data-id="element-359">
                      Sistema completo de rutinas visuales y límites amables
                      para transformar las mañanas, noches y comidas en momentos
                      de conexión y cooperación.
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-8" data-id="element-360">
                <div className="md:w-1/2" data-id="element-361">
                  <h3 className="text-xl font-bold text-amber-900 mb-4" data-id="element-362">
                    Cría con calma: Kit Completo
                  </h3>
                  <ul className="space-y-3 mb-6" data-id="element-363">
                    <li className="flex items-start gap-2" data-id="element-364">
                      <CheckCircle className="text-amber-700 mt-1 flex-shrink-0" size={18} data-id="element-365" />
                      <span className="text-amber-900" data-id="element-366">
                        Tableros de Rutina Mañana/Noche imprimibles
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-367">
                      <CheckCircle className="text-amber-700 mt-1 flex-shrink-0" size={18} data-id="element-368" />
                      <span className="text-amber-900" data-id="element-369">
                        Guiones de 3 pasos para berrinches y transiciones
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-370">
                      <CheckCircle className="text-amber-700 mt-1 flex-shrink-0" size={18} data-id="element-371" />
                      <span className="text-amber-900" data-id="element-372">
                        Contrato Familiar de Pantallas personalizable
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-373">
                      <CheckCircle className="text-amber-700 mt-1 flex-shrink-0" size={18} data-id="element-374" />
                      <span className="text-amber-900" data-id="element-375">
                        Recetario exprés: 12 cenas en 15–20 minutos
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-376">
                      <CheckCircle className="text-amber-700 mt-1 flex-shrink-0" size={18} data-id="element-377" />
                      <span className="text-amber-900" data-id="element-378">
                        Guía de implementación paso a paso
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-379">
                      <CheckCircle className="text-amber-700 mt-1 flex-shrink-0" size={18} data-id="element-380" />
                      <span className="text-amber-900" data-id="element-381">
                        Tarjetas de calma para autorregulación
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="md:w-1/2" data-id="element-382">
                  <div className="bg-amber-50 rounded-lg p-4 border border-amber-200 mb-6" data-id="element-383">
                    <div className="flex items-center gap-2 mb-2" data-id="element-384">
                      <Gift className="text-amber-700" size={20} data-id="element-385" />
                      <h4 className="font-bold text-amber-900" data-id="element-386">
                        BONUS #1: Valor $8.00
                      </h4>
                    </div>
                    <div className="flex gap-4" data-id="element-387">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2oadB5wcwu12AXzYiTyU2r/ChatGPT_Image_8_oct_2025%2C_11_48_00_p.m..png" alt="Ebook de Comunicación Positiva" className="w-24 h-32 object-cover rounded-md shadow-md" data-id="element-388" />
                      <div data-id="element-389">
                        <h5 className="font-bold text-amber-900" data-id="element-390">
                          Comunicación positiva en 100 frases
                        </h5>
                        <p className="text-sm text-amber-800" data-id="element-391">
                          Frases prácticas para conectar con tus hijos en
                          momentos difíciles y transformar conflictos en
                          oportunidades.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-amber-50 rounded-lg p-4 border border-amber-200 mb-6" data-id="element-392">
                    <div className="flex items-center gap-2 mb-2" data-id="element-393">
                      <Gift className="text-amber-700" size={20} data-id="element-394" />
                      <h4 className="font-bold text-amber-900" data-id="element-395">
                        BONUS #2: Valor $12.00
                      </h4>
                    </div>
                    <div className="flex gap-4" data-id="element-396">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gj9MVsUWuUPsgYFG28x4PS/ChatGPT_Image_8_oct_2025%2C_11_41_25_p.m..png" alt="Kit de Rutinas y Tarjetas Imprimibles" className="w-24 h-32 object-cover rounded-md shadow-md" data-id="element-397" />
                      <div data-id="element-398">
                        <h5 className="font-bold text-amber-900" data-id="element-399">
                          Kit de Rutinas y Tarjetas Imprimibles
                        </h5>
                        <p className="text-sm text-amber-800" data-id="element-400">
                          Material adicional para complementar las rutinas con
                          tarjetas visuales para diferentes momentos del día.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-amber-100 pt-6 mt-2" data-id="element-401">
                <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-402">
                  <div className="mb-4 md:mb-0" data-id="element-403">
                    <div className="flex items-baseline gap-2" data-id="element-404">
                      <p className="text-lg text-amber-800" data-id="element-405">Valor total:</p>
                      <p className="font-bold text-2xl text-amber-900" data-id="element-406">
                        $47.99
                      </p>
                    </div>
                    <div className="flex items-baseline gap-2" data-id="element-407">
                      <p className="text-lg text-amber-800" data-id="element-408">Tu precio hoy:</p>
                      <p className="font-bold text-3xl text-amber-700" data-id="element-409">$7.99</p>
                    </div>
                    <p className="text-sm text-amber-600 mt-1" data-id="element-410">
                      ¡Ahorras $40.00 (83% de descuento)!
                    </p>
                  </div>
                  <a href="https://pay.hotmart.com/E103092077E" onClick={handlePurchaseClick} data-id="element-411">
                    <button className="bg-amber-700 hover:bg-amber-800 text-white font-bold text-lg py-3 px-8 rounded-md shadow-md transition-all hover:shadow-lg w-full md:w-auto" data-id="element-412">
                      ¡Lo quiero ahora!
                    </button>
                  </a>
                </div>
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 mt-6 flex items-center justify-center gap-2" data-id="element-413">
                  <AlertTriangle className="text-red-600" size={20} data-id="element-414" />
                  <p className="text-red-600 font-medium text-sm" data-id="element-415">
                    ¡Solo quedan <span className="font-bold" data-id="element-416">5 copias</span> a
                    este precio especial!
                  </p>
                </div>
                <p className="text-center text-sm text-amber-600 mt-6" data-id="element-417">
                  Oferta por tiempo limitado • Acceso inmediato • Sin
                  suscripciones
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}